<template>
    <v-form
        ref="form"
        v-model="valid"
        @submit="onSubmitQouteSettings"
        class="mt-3">
        <v-container fluid>
            <v-row>
                <v-col md="4">
                    <v-select
                        v-model="form.margin_type"
                        :error-messages="marginTypeErrors"
                        :items="marginTypes"
                        label="Margin Types"
                        required
                        @input="$v.form.margin_type.$touch()"
                        @blur="$v.form.margin_type.$touch()">
                    </v-select>
                </v-col>
            </v-row>


            <v-row v-if="form.margin_type == 'AUD'">
                <v-col md="4">
                    <v-text-field
                        v-model="form.amount"
                        type="number"
                        :error-messages="amountErrors"
                        label="Amount (AUD)"
                        required
                        @input="$v.form.amount.$touch()"
                        @blur="$v.form.amount.$touch()">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row v-else-if="form.margin_type == '%'">
                <v-col md="4">
                    <v-text-field
                        v-model="form.amount"
                        type="number"
                        :error-messages="amountErrors"
                        label="Percentage (%)"
                        required
                        @input="$v.form.amount.$touch()"
                        @blur="$v.form.amount.$touch()">
                    </v-text-field>
                </v-col>
                <v-col>
                    <v-radio-group
                        :error-messages="roundingErrors"
                        v-model="form.rounding"
                        required
                        @input="$v.form.rounding.$touch()"
                        @blur="$v.form.rounding.$touch()">
                        <v-radio
                            label="No Rounding"
                            value="0"
                        ></v-radio>
                        <v-radio
                            label="Rounding Up"
                            value="up"
                        ></v-radio>
                        <v-radio
                            label="Rounding Down"
                            value="down"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row>
                <v-col md="4">
                    <v-text-field
                        v-model="form.minimum_shipping_cost"
                        type="number"
                        :error-messages="minimumShippingCostErrors"
                        label="Minimum Shipping Cost"
                        @input="$v.form.minimum_shipping_cost.$touch()"
                        @blur="$v.form.minimum_shipping_cost.$touch()">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <p>Use origin location from rates?</p>
                    <v-radio-group v-model="form.is_origin_use" row>
                        <v-radio label="yes" value="1"></v-radio>
                        <v-radio label="no" value="0"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <p>Hide delivery date estimate?</p>
                    <v-radio-group v-model="form.is_hide_delivery" row>
                        <v-radio label="yes" value="1"></v-radio>
                        <v-radio label="no" value="0"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row v-if="form.is_hide_delivery == 0">
                <v-col md="4">
                    <v-text-field
                        v-model="form.add_transit_days"
                        type="number"
                        label="Add Transit Days"
                        @input="$v.form.add_transit_days.$touch()"
                        @blur="$v.form.add_transit_days.$touch()">
                    >
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn small type="submit" color="primary">Update Settings</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import { EventBus } from '../../../../../../event-bus.js'
    import { validationMixin } from 'vuelidate'
    import { required, numeric, decimal } from 'vuelidate/lib/validators'
    import { mapState } from "vuex"

    export default {
        props: {
            id: { type: Number, default: null },
        },

        mixins: [validationMixin],

        validations() {
            return {
                form: {
                    amount: { required },
                    margin_type: { required },
                    rounding: { required },
                    minimum_shipping_cost: {decimal},
                    add_transit_days: {numeric},
                }
            };
        },

        computed: {
            minimumShippingCostErrors() {
                const errors = [];
                if (!this.$v.form.minimum_shipping_cost.$dirty) return errors;
                if (!this.$v.form.minimum_shipping_cost.decimal) {
                    errors.push('Minimum Shipping Cost must be a valid number.');
                }

                return errors;
            },

            // Error computation for the amount field
            amountErrors() {
                const errors = []
                if (!this.$v.form.amount.$dirty) return errors
                let type = this.form.margin_type == 'AUD' ? 'Amount' : 'Percentage';
                !this.$v.form.amount.required && errors.push(`${type} is required.`)
                return errors
            },

            marginTypeErrors() {
                const errors = []
                if (!this.$v.form.margin_type.$dirty) return errors
                !this.$v.form.margin_type.required && errors.push('Margin type is required.')
                return errors
            },

            roundingErrors() {
                const errors = []
                if (!this.$v.form.rounding.$dirty) return errors
                !this.$v.form.rounding.required && errors.push('Rounding is required.')
                return errors
            },

            integrationId() {
                return this.id;
            },

            ...mapState('LRSettingsState', {
                form: 'qouteForm'
            })
        },

        data() {
            return {
                valid: false,
                marginTypes: [
                    { text: 'Percentage (%)', value: '%' },
                    { text: 'Fixed ($)', value: 'AUD' },
                    { text: 'None', value: 'n' },
                ],
                isLoading: false,
            }
        },

        methods: {
            onSubmitQouteSettings(e) {
                this.$v.form.$touch();
                e.preventDefault();

                // Simply force amount to "0" if margin type is 'n'
                if (this.form.margin_type === 'n') {
                    this.form.amount = "0";
                    this.form.rounding = "0";
                }

                if (!this.$v.$invalid) {
                    setTimeout(() => {
                        if (this.valid) {
                            // determine whether we add/create
                            if (this.form.id) {
                                this.onUpdateQouteSettings()
                            } else {
                                this.onCreateQouteSettings()
                            }

                        } else {
                            EventBus.$emit('show-error', 'Failed! Please try again.');
                        }
                    }, 500);
                } else {
                    EventBus.$emit('show-error', 'Failed! Please try again.');
                }
            },

            onCreateQouteSettings() {
                this.isLoading = true
                let param = this.form
                param.integration_id = this.integrationId
                this.$http
                    .post('/api/live-rates/settings', param)
                    .then(({ data }) => {
                        EventBus.$emit('show-success', 'Successfully saved qoute settings.');
                        this.isLoading = false
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err);
                        this.isLoading = false
                    })
            },

            onUpdateQouteSettings() {
                this.isLoading = true
                this.$http
                    .put('/api/live-rates/settings/' + this.form.id, this.form)
                    .then(({ data  }) => {
                        EventBus.$emit('show-success', 'Successfully updated qoute settings.');
                        this.isLoading = false
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err);
                        this.isLoading = false
                    })
            },

        },
    }
</script>
